import styled from "styled-components";
import { Font, Color, breakpoints, ColorDark } from "@/shared/Constants";

export const MenuVintage = styled.div`
  padding-left: 20px;
  cursor: pointer;
  position: relative;
  ${breakpoints.phone} {
    padding-left: 15px;
  }
`;

export const MenuList = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  background-color: ${Color.white};
  position: fixed;
  padding: 0 18px;
  z-index: 2;
  width: 989px;
  border-right: 1px solid ${Color.greySeparator};
  ${breakpoints.phone} {
    width: 100%;
    border-right: none;
  }
  ${breakpoints.darkMode} {
    [data-theme="dark"] & {
      background-color: ${ColorDark.backDarknew};
    }
  }
  .menu-close-button {
    position: absolute;
    top: 15px;
    left: 15px;
    cursor: pointer;
    svg {
      ${breakpoints.darkMode} {
        [data-theme="dark"] & {
          fill: ${ColorDark.textLight};
        }
      }
    }
  }
  .menu-list-items {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 20px;
    width: 100%;
    margin-top: 100px;
    margin-bottom: 60px;
    z-index: 999;
    a {
      ${Font.vintageGeorgia}
      color: ${Color.secondaryBlack};
      font-size: 21px;
      line-height: 1.5;
      cursor: pointer;
      width: 100%;
      &:visited {
        color: ${Color.secondaryBlack};
        ${breakpoints.darkMode} {
          [data-theme="dark"] & {
            color: ${ColorDark.textLight};
          }
        }
      }
      &:first-of-type {
        border-bottom: 1px solid ${Color.greySeparator};
        padding-bottom: 20px;
        ${breakpoints.darkMode} {
          [data-theme="dark"] & {
            border-bottom: 1px solid ${ColorDark.greySeparator};
          }
        }
      }
      ${breakpoints.phone} {
        font-size: 18px;
      }
      ${breakpoints.darkMode} {
        [data-theme="dark"] & {
          color: ${ColorDark.textLight};
        }
      }
    }
  }
  &.isOpen {
    top: 0;
    opacity: 1;
    transition: all 0.3s ease-in;
  }
  &.isClose {
    top: -100%;
    opacity: 0;
    transition: all 0.5s ease-out;
  }
`;
